import { type RequirementIdentifier } from '@capsicum/common';
import { useEffect } from 'react';

import { useGetRequirementByIdentifierQuery, useGetRequirementStateByIdentifierQuery } from '../data-access';

type RequirementProps = {
	isForcedRequirement?: boolean;
	requirementIdentifier: RequirementIdentifier;
	showDeniedRequirementModal: () => void;
};

export const useRequirement = ({
	isForcedRequirement,
	requirementIdentifier,
	showDeniedRequirementModal
}: RequirementProps) => {
	const { data: requirement, isFetching } = useGetRequirementByIdentifierQuery({
		requirementIdentifier: requirementIdentifier
	});

	const { data: requirementState, isFetching: isFetchingState } = useGetRequirementStateByIdentifierQuery({
		requirementIdentifier: requirementIdentifier
	});

	const status = requirementState?.status;

	const isRequirementStatusDenied = status === 'completed_deny';

	const cannotShowRequirement = isForcedRequirement && isRequirementStatusDenied;

	useEffect(() => {
		if (cannotShowRequirement) showDeniedRequirementModal();
	}, [cannotShowRequirement]);

	const showLoader = isFetching || isFetchingState || cannotShowRequirement;

	return {
		requirement,
		showLoader,
		status
	};
};
